export default __webpack_public_path__ + "static/media/video-bg.698df8a0.png";